<template>
  <v-app id="inspire">
    <v-main>
      <v-fade-transition duration="150" mode="out-in">
        <router-view> </router-view>
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>
